(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/add', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/add'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.add, global.convert);
    global.add = mod.exports;
  }
})(this, function (exports, _add2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.add = undefined;

  var _add3 = _interopRequireDefault(_add2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by the addition of the former number and the given number.
   * @function
   * @memberof math
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} addend The number to add.
   * @return {Object} Returns the updated object.
   * @example add({ nested: { prop: 2 } }, 'nested.prop', 4) // => { nested: { prop: 6 } }
   * @see {@link https://lodash.com/docs#add|lodash.add} for more information.
   * @since 0.1.7
   */
  var add = (0, _convert.convert)(_add3.default);
  exports.add = add;
  exports.default = add;
});